// src/data/api/helios-service/tagService.ts

import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  ListTagsRequest,
  ListTagsResponse,
  CreateTagRequest,
  CreateTagResponse,
  UpdateTagRequest,
  UpdateTagResponse,
  GetTagRequest,
  GetTagResponse,
  DeleteTagRequest,
} from 'src/types/helios/Tags';

export const tagService = {
  // Get all tags
  getAll: (data: ListTagsRequest) => {
    return apiClient.get<ListTagsResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TAGS.LIST(data.programId, data.businessUnitId),
      ),
      data,
    );
  },

  // Create tag
  createTag: (data: CreateTagRequest) => {
    return apiClient.post<CreateTagResponse, CreateTagRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TAGS.CREATE(data.programId, data.businessUnitId),
      ),
      data,
    );
  },

  // Update tag
  updateTag: (data: UpdateTagRequest) => {
    return apiClient.put<UpdateTagResponse, UpdateTagRequest>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TAGS.UPDATE(
          data.programId,
          data.businessUnitId,
          data.tagId,
        ),
      ),
      data,
    );
  },

  // Get tag
  getTag: (data: GetTagRequest) => {
    return apiClient.get<GetTagResponse>(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TAGS.GET(
          data.programId,
          data.businessUnitId,
          data.tagId,
        ),
      ),
      data,
    );
  },

  // Delete tag
  deleteTag: (data: DeleteTagRequest & { deletedBy?: string }) => {
    return apiClient.delete(
      ServiceType.HELIOS,
      createApiUrl(
        API_ENDPOINTS.HELIOS_SERVICE.TAGS.DELETE(
          data.programId,
          data.businessUnitId,
          data.tagId,
        ),
      ),
      undefined,
      data.deletedBy,
    );
  },
};
